export default {
  menu: {
    index: '公共模板',
    works: '我的作品',
    myTemplate: '我的模板',
    stars: '我的收藏',
  },
  suggestionDialog: {
    title: '制作建议',
    context:
      '· 自由编辑器内不限制任何操作，<br/>· 建议不要删除核心玩法图层/场景，否则可能会导致底层逻辑异常从而可玩广告无法正常试玩，<br/>· 制作完成请务必预览效果。',
  },
  saveAsTemplate: {
    label: '存为模板',
    cancel: '取消',
    confirm: '确认',
    form: {
      nameLabel: '模板名称',
      name: '请输入模板名称',
      emptyName: '请输入模板名称',
      overName: '名称不能超过50个字符',
    },
    copy: '复制',
    rename: '重命名',
    success: '模板保存成功',
  },
  previewDialog: {
    next: '下一个',
    prev: '上一个',
    create: '换肤编辑',
    createTips:
      '在可玩模板的基础上替换资源、调整资源大小、调整玩法参数，快速导出高质量可玩广告。',
    free: '自由编辑',
    freeTips:
      '除「换肤编辑」支持的操作外，还可对模板做进一步的调整。如更改排版、新增资源、修改事件等等，将模板素材迭代出N多版本。',
    qrcodeLabel: '手机查看',
    skinLabel: '选择皮肤',
    difficulty: '难度等级',
    modelCount: '模型数量',
    actionCount: '动作数量',
  },
  index: {
    listEmpty: '当前列表为空',
    listDesc: '抱歉，没有找到符合条件的结果，建议更换不同的搜索条件。',
    saveListEmpty: '您还没有收藏模板',
    leaveMessage: {
      title: '留言',
      desc: '给我们，试用更多模板',
    },
    checkall: '查看全部模板',
    filters: {
      category: '类型',
      classify: '分类',
      industry: '行业',
      originality: '创意',
      difficulty: '难度',
      playMethod: '玩法',
      productType: '制作',
      all: '全部',
      new: '最新',
      hot: '最热',
      more: '展开更多',
      back: '收起',
    },
    list: {
      starButton: '收藏',
      useTemplate: '使用模板',
      unsave: '取消收藏',
      saveSuccess: '收藏成功',
    },
    estimated: '制作时长',
    createFromBlank: '空白制作',
  },
  works: {
    listEmpty: '当前列表为空',
    dcoStatus: '未发布',
    listNormal: '您还没有创建项目，立即挑选合适的模板开始创作吧！',
    listMgroup:
      '多组合制作是一种高效批量制作方式，可同时产出多个作品进行AB测试。您可以为需要调整的位置添加资产，一次性下载所有排列组合的作品（最多27个组合）',
    listDCO:
      'DCO制作是一种支持广告智能投放能力的制作方式，其产出的一个包体可千人千面展示不同的内容。您可以针对我们开放的位置添加备选资产，将作品推送至 SS 对应的账户加入投放计划后，Mintegral将会依据算法在每一个位置挑选出优选资产进行组合，提升转化。',
    infoTitle: '我的作品',
    infoContent: '我们同时支持多组合制作及DCO制作，助力快速生产及智能投放。',
    psMgroup:
      '通过简单的「拖拉拽」PPT式操作，无需任何代码，您可以自由组合图片、文本、音频、视频和特效，进行个性化可玩广告制作。',
    ivMgroup:
      '无需专业技能，借助可视化脚本设计，只需在视频时间轴上添加触发事件，轻松将普通视频转化为交互视频，快速实现互动效果。',
    projectType: {
      normal: '普通制作',
      normalEditor: '换肤编辑器',
      dco: 'DCO制作',
      mgroup: '多组合制作',
      mgroupEditor: '多组合换肤编辑器',
      ps: '自由编辑器',
      iv: '视频转可玩',
    },
    projectPlaceHolder: '请输入作品名称',
    table: {
      column: {
        name: '作品',
        type: '作品类型',
        template: '模板名称',
        status: '制作进度',
      },
    },
    status: {
      all: '全部进度',
      making: '制作中',
      downloaded: '已下载',
      reviewing: '审核中',
      pushed: '已推送',
      pushFaild: '推送失败',
      pending: '推送中',
      partSuccess: '部分已推送',
    },
    options: {
      edit: '编辑',
      product: '修改产品信息',
    },
  },
  myTemplate: {
    menu: {
      update: '更新模板',
      copy: '复制模板',
      delete: '删除模板',
      edit: '修改模板名称',
    },
    sort: {
      createdTimeNear: '创建时间(由近到远)',
      createdTimeFar: '创建时间(由远到近)',
      updatedTimeNear: '更新时间(由近到远)',
      updatedTimeFar: '更新时间(由远到近)',
    },
    sortOrder: {
      createdTime: '创建时间',
      updatedTimer: '更新时间',
    },
    status: {
      check: '待检查',
      unauthorized: '未授权',
    },
  },
  subscribe: {
    renew: '续订',
    expired: '订阅服务已到期',
    hasNotSubscribe: '尚未开启订阅服务',
    timeLeft: '还有 {{timeLeft}} 天到期',
    hasNotSubscribeAlertTitle: '尚未开启订阅服务，立即申请吧！',
    expiredAlertTitle: '订阅服务已到期，立即续订吧！',
    renewExpiredAlertTitle: '续订申请',
    alertDesc: '填写下表，我们将尽快答复您的请求。',
    form: {
      name: {
        label: '姓名',
        placeholder: '请输入您的姓名',
      },
      email: {
        label: '邮箱',
        placeholder: '请输入您的收件邮箱',
      },
      month: {
        label: '订阅时长',
        placeholder: '订阅时长',
        optionTail: '个月',
      },
      remark: {
        label: '备注',
        placeholder: '其他联系方式或需求备注',
      },
    },
    submitSuccess: {
      title: '订阅申请已提交，我们将尽快答复您的请求。',
      desc: '如有其他疑问，可发邮件至 <a href="mailto:support@mindworks-creative.com">support@mindworks-creative.com</a>。',
    },
  },
  resetTemplate: {
    text: '恢复默认值',
    warnTitle: '确定全局恢复默认吗？',
    warnDetail: '所有更改都将恢复为默认值。',
  },
  versionEditTitle: '编辑项目信息',
  creativeInfo: {
    action: {
      create: '新建',
      update: '更新',
      copy: '复制',
    },
    type: {
      create: {
        normal: '换肤编辑制作',
        mgroup: '多组合换肤制作',
        dco: 'DCO 制作',
        playsmart: '自由编辑制作',
        createPlayable: '创建作品',
        directCreate: '直接创建',
        psdCreate: 'PSD导入',
        iv: '视频转可玩',
      },
      copy: {
        normal: '复制',
        mgroup: '复制至多组合',
        dco: '复制至 DCO',
        playsmart: '复制至自由编辑',
        iv: '复制至互动视频编辑器',
      },
    },
    form: {
      versionName: {
        label: '版本名称',
        placeholder: '请输入版本名称',
        validateMessage: '仅支持数字、字母、下划线，50个字符以内',
        empty: '版本名称不能为空',
      },
      name: {
        label: '项目名称',
        placeholderProject: '请输入项目名称',
        placeholder: '仅支持数字、字母、下划线，50个字符以内',
        validateMessage: '仅支持数字、字母、下划线，50个字符以内',
        empty: '项目名称不能为空',
      },
      promotedType: {
        label: '产品类型',
        empty: '产品类型不能为空',
      },
      appInfo: '推广产品信息（用于CTA跳转及加载页面）',
      appIcon: {
        label: '产品图标',
        tips: '随提供的商店链接抓取对应的图标',
      },
      appName: {
        label: '产品名称',
        tips: '随提供的商店链接抓取对应的名称',
        empty: '产品名称不能为空',
      },
      url: {
        label: '跳转 URL',
        placeholder: 'URL.',
        empty: '跳转 URL 不能为空',
        valid: '跳转 URL 格式错误',
      },
      iOSURL: {
        label: 'iOS URL',
        placeholder: 'Apple App Store URL.',
        empty: '跳转 URL 不能为空',
      },
      androidURL: {
        label: 'Android URL',
        placeholder: 'Google Play/Android App Store URL.',
        empty: '跳转 URL 不能为空',
      },
      platform: {
        label: '平台选择',
        empty: '平台选择不能为空',
      },
      direction: {
        label: '适配方向',
        tips: '投放 Mintegral 渠道需同时支持橫屏和竖屏',
        placeholder: '请选择适配方向',
        options: {
          adaptive: {
            label: '横屏 & 竖屏',
            desc: '需要分别对竖屏和横屏进行排版制作，投放时会按照您制作的页面进行展示',
            tips: '投放Mintegral建议选择此项',
          },
          landscape: {
            label: '横屏',
            desc: '仅需要完成横屏排版制作。投放到竖屏APP时，将会按照横屏效果进行缩小展示',
          },
          portrait: {
            label: '竖屏',
            desc: '仅需要完成竖屏排版制作。投放到横屏APP时，将会按照竖屏效果缩小展示',
          },
          see: '，详见',
          help: '帮助中心',
        },
      },
      language: {
        label: '初始语言',
        placeholder: '请选择初始语言',
        empty: '初始语言不能为空',
      },
      quality: {
        label: '压缩质量',
        title: '质量控制',
      },
      psd: {
        title: 'PSD导入(默认适配横竖屏)',
        uploadTip1: '拖放文件到此处，或点击即可立即上传',
        uploadTip2: '单文件: 直接上传1个PSD文件',
        uploadTip3: '横竖版: 将两个psd文件打成zip压缩包并保持文件在根目录上传',
        uploadTip4: '压缩图片: 尺寸不改，数值越高质量越高文件越大',
        uploading: '上传中',
        error: '上传失败，请重新上传',
        emptyError: 'psd文件不能为空',
        psdError: 'psd文件有误',
        psdErrorName: '文件名必须是英文、数字、下划线',
      },
      psd2uiErr: {
        firstLv: '图层的第一层级只能是game',
        scenePlayGlobal:
          'game图层下的第一层级按顺序需要是xxx@scene, xxx@global, xxx@play',
        zip: 'zip包内必须是2个psd文件',
        layerEmpty:
          '横竖版psd,图层存在至少一个为空,请对比横竖版图层差异! 竖版: {layersPName}, 横版: {layersLName}',
        layerDiff:
          '横竖版psd的图层名不同,请对比图层。竖版: {layersPName}, 横版: {layersLName}',
        emptyImg:
          '图层未载入成功，存在无像素图层: {path} (建议用纯色块来替代该无像素图层，后续再用透明图片替换)',
        rasterized: '图层{path}需要栅格化才能导出图片',
        validName: 'zip包内的文件名必须是英文、数字、下划线',
      },
    },
  },
}
